import { render, staticRenderFns } from "./LabelValueHtmlRender.vue?vue&type=template&id=112c25e4&functional=true&v-slot%3A%5B%60label%60%5D=true"
import script from "./LabelValueHtmlRender.vue?vue&type=script&lang=js"
export * from "./LabelValueHtmlRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('112c25e4')) {
      api.createRecord('112c25e4', component.options)
    } else {
      api.rerender('112c25e4', component.options)
    }
    module.hot.accept("./LabelValueHtmlRender.vue?vue&type=template&id=112c25e4&functional=true&v-slot%3A%5B%60label%60%5D=true", function () {
      api.rerender('112c25e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LabelValueHtmlRender.vue"
export default component.exports